/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ScandiInputs */

const cs_enum_scandi = /** @type {(inputs: Enum_ScandiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skandinávský`)
};

const en_enum_scandi = /** @type {(inputs: Enum_ScandiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scandi`)
};

/**
* | output |
* | --- |
* | "Scandi" |
*
* @param {Enum_ScandiInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_scandi = /** @type {((inputs?: Enum_ScandiInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ScandiInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_scandi(inputs)
	return cs_enum_scandi(inputs)
});